import {CharacterIdentifier} from "./characterInfo";

const CHARACTER_BACKGROUND_VIDEO_BASE_URL =
  process.env.REACT_APP_CHARACTER_BACKGROUND_VIDEO_BASE_URL;

export const CHARACTER_BACKGROUND_VIDEO_URLS: Record<string, string> = {
  [CharacterIdentifier.RIZUKO]: `${CHARACTER_BACKGROUND_VIDEO_BASE_URL}/character_animation_rizuko.mp4`,
  [CharacterIdentifier.SONGYONGDOLI]: `${CHARACTER_BACKGROUND_VIDEO_BASE_URL}/character_animation_songyongdoli.mp4`,
  [CharacterIdentifier.URAKBAM]: `${CHARACTER_BACKGROUND_VIDEO_BASE_URL}/character_animation_urakbam.mp4`,
  [CharacterIdentifier.TONYANGDEOK]: `${CHARACTER_BACKGROUND_VIDEO_BASE_URL}/character_animation_tonyangdeok.mp4`,
  [CharacterIdentifier.DDOLBYEONG]: `${CHARACTER_BACKGROUND_VIDEO_BASE_URL}/character_animation_ddolbyeong.mp4`,
  [CharacterIdentifier.MEONGRYONGIE]: `${CHARACTER_BACKGROUND_VIDEO_BASE_URL}/character_animation_meongryongie.mp4`,
  [CharacterIdentifier.KARANGI]: `${CHARACTER_BACKGROUND_VIDEO_BASE_URL}/character_animation_karangi.mp4`,
  [CharacterIdentifier.GELBULNYANGI]: `${CHARACTER_BACKGROUND_VIDEO_BASE_URL}/character_animation_gelbulnyangi.mp4`,
  [CharacterIdentifier.MUNGTENGI]: `${CHARACTER_BACKGROUND_VIDEO_BASE_URL}/character_animation_mungtaengi.mp4`,
  [CharacterIdentifier.RWE]: `${CHARACTER_BACKGROUND_VIDEO_BASE_URL}/character_animation_rwe.mp4`,
};

export const getBackgroundVideoUrl = (characterIdentifier: string): string => {
  const url = CHARACTER_BACKGROUND_VIDEO_URLS[characterIdentifier];
  if (url) {
    return url;
  }
  return CHARACTER_BACKGROUND_VIDEO_URLS[CharacterIdentifier.RIZUKO];
};
